import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white text-brand-black">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-5 py-12 sm:grid-cols-3 sm:px-8">
        <div>
          <div className="flex items-center">
            <img
              src="/logo/logo-lg.webp"
              alt="The 7 Figure Cleaner logo"
              className="h-[82px] w-auto object-contain"
              width="800"
              height="288"
            />
          </div>
          <p className="mt-4 text-sm leading-relaxed text-brand-grayMid">
            A complete customer-acquisition and follow-up system for exterior cleaners across Australia. Meta ads, LEO AI follow-up and the 7FC Job Hub — $250 / week + GST, no lock-in.
          </p>
        </div>
        <div>
          <h4 className="text-xs font-black uppercase tracking-widest text-brand-black">Links</h4>
          <ul className="mt-4 flex flex-col gap-2 text-sm text-brand-grayMid">
            <li><a className="transition-colors hover:text-brand-blue" href="/#results">Results</a></li>
            <li><a className="transition-colors hover:text-brand-blue" href="/#pricing">Pricing</a></li>
            <li><a className="transition-colors hover:text-brand-blue" href="/#faq">FAQ</a></li>
            <li><Link className="transition-colors hover:text-brand-blue" to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-black uppercase tracking-widest text-brand-black">Check Availability</h4>
          <p className="mt-4 text-sm text-brand-grayMid">One operator per area. See if your territory is still open.</p>
          <Link
            to="/offer"
            className="mt-4 inline-flex items-center justify-center rounded-2xl bg-brand-blue px-5 py-3 text-xs font-black uppercase tracking-wider text-white shadow-lg shadow-blue-200/60 ring-1 ring-blue-700/10 transition-all hover:bg-blue-600 active:scale-[0.99]"
          >
            Check My Territory
          </Link>
        </div>
      </div>
      <div className="border-t border-gray-200">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-5 py-5 text-xs text-brand-grayMid sm:flex-row sm:px-8">
          <p>© {new Date().getFullYear()} The 7 Figure Cleaner. ABN 17 639 251 027. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/privacy" className="transition-colors hover:text-brand-blue">Privacy</Link>
            <Link to="/terms" className="transition-colors hover:text-brand-blue">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
